export var _common_data = {
    menu: [
        { text: 'продукция', link: '/products/' },
        { text: '#едимкутим', link: '/' },
        { text: 'призы', link: '/prizes/' },
        { text: 'рецепты для вечеринок', link: '/recipes/' },
        { text: 'условия акции', link: '/files/rules.pdf', newWin: true },
        { text: 'рейтинг', link: '/rating/' },
        { text: 'результат', link: '/collage/' },
        { text: 'победители', link: '/winners/' },
    ],
    logo: { img: '/img/logo-main.svg', link: '/', goalName: ' logo' },
};
